import { Hint, Td, TRow } from '@tecsinapse/cortex-react'
import React, { useEffect, useRef } from 'react'
import { isDealer } from '@/core/enums/tipo-usuario'
import type { OptionSelect } from '@/core/utils/types'
import CargosUsuarioTable from './cargos-usuario-table'
import { useFormState, useWatch } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

const MONTADORA_DEALER = { value: '', label: '' }

const CargoUsuarioField = ({
  name,
  append,
  remove,
  showDepartamentos,
  departamentoOptions,
  setOpenTour,
  tourId
}) => {
  const { errors } = useFormState()
  const values = useWatch()
  const isDealerGrupo = isDealer(values.tipo?.value)
  const openRef = useRef(false)
  const hasCargos = values?.cargos?.length > 0

  useEffect(() => {
    if (!openRef.current && hasCargos && tourId) {
      openRef.current = true
      setOpenTour?.()
    }
  }, [hasCargos, name, setOpenTour, tourId])

  return (
    <div className='flex gap-5 flex-col'>
      {errors[name] ? (
        <ErrorMessage
          name={name}
          errors={errors}
          render={({ message }) => (
            <Hint variants={{ intent: 'error' }}>{message}</Hint>
          )}
        />
      ) : null}
      {isDealerGrupo ? (
        values.idsDealers.map((dealer: OptionSelect) => (
          <div key={dealer.value}>
            <CargosUsuarioTable
              dealer={dealer}
              append={append}
              remove={remove}
              values={values}
              showDepartamentos={showDepartamentos}
              departamentoOptions={departamentoOptions}
              key={dealer.value}
              tourId={tourId}
            >
              <TRow className='w-full'>
                <Td colSpan={99}>
                  <p className='text-h5 font-bold'>{dealer.label}</p>
                </Td>
              </TRow>
            </CargosUsuarioTable>
          </div>
        ))
      ) : (
        <CargosUsuarioTable
          dealer={MONTADORA_DEALER}
          append={append}
          remove={remove}
          values={values}
          showDepartamentos={showDepartamentos}
          departamentoOptions={departamentoOptions}
          tourId={tourId}
        />
      )}
    </div>
  )
}

export default CargoUsuarioField
